import { render, staticRenderFns } from "./StatsPreDeliveries.vue?vue&type=template&id=536b5ab5"
import script from "./StatsPreDeliveries.vue?vue&type=script&lang=ts"
export * from "./StatsPreDeliveries.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports